import React from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import {useTranslation} from "react-i18next";
import Title from "../../../components/elements/Title";
import MakePage from "./MakePage";


function OrganizationsPage({edit}){
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={!!edit ? t('editPage') : t('addPage')}>
            <Grid container spacing={2} justifyContent="center">
                <Grid item size={{xs:12,md:10,lg:8}} >
                    <Title align="left" color="text">{!!edit ? t('editPage') : t('addPage')}</Title>
                    <MakePage/>
                </Grid>
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(OrganizationsPage);
